export type PeopleSearchRequest = {
  orgId: number;
  search: string;
  onlyActive?: boolean;
  type?: string;
  userRoleBlacklist?: number[];
  useRoleBasedSearch?: boolean;
};

export type PeopleSearchSuccessResponseSchemaContract = {
  label: string;
  key: number;
  title: null | string;
  role: null | string;
}[];

export const PeopleSearchSuccessResponseSchema = {
  type: 'array',
  items: {
    type: ['object'],
    properties: {
      key: { type: 'number' },
      label: { type: 'string' },
      title: { type: ['null', 'string'] },
      role: { type: ['null', 'string'] },
    },
    required: ['key', 'label'],
  },
};

export type SaveUserUiPreferenceRequestData = {
  [key: string]: any;
};

export type PayrollStatusForGivenDateContract = {
  id: number;
  date: string;
  isFinal: boolean;
  isBlocked: boolean;
};

export type PayrollStatusForGivenDateRequest = {
  userOrgId: number | string;
  date: string;
  isDismissalDate?: boolean;
};

export const PayrollStatusForGivenDateSchema = {
  type: 'object',
  properties: {
    id: { type: 'number' },
    date: { type: 'string' },
    isFinal: { type: 'boolean' },
    isBlocked: { type: 'boolean' },
  },
  required: ['isFinal', 'isBlocked'],
};
